import React, { useEffect, useState } from 'react'
import { Router, Switch, Route, Redirect, Link, useLocation } from 'react-router-dom'

import CoordinatorDashboardPage from './containers/CoordinatorDashboardPage'
import CoordinatorTaskRedirectPage from './containers/CoordinatorTaskRedirectPage'
import SupplierDataTab from 'rest/views/coordinator/supplier/data/Tab'
import SupplierPublicProfile from 'rest/views/coordinator/supplier/Profile'
import SupplierPage from 'containers/SupplierPage'
import SupplierSearchPage from 'containers/SupplierSearchPage'
import OrderSearchPage from 'containers/OrderSearchPage'
import CustomersIdlePage from 'containers/CustomersIdlePage'
import CustomersSuccessTeamsPage from 'containers/CustomersSuccessTeamsPage'
import HandoverPage from 'containers/HandoverPage'
import OrderFilesPage from 'containers/OrderFilesPage'
import NotificationsPage from 'containers/NotificationsPage'
import CommandPalette from 'containers/CommandPalette'
import SupplierDemos from 'containers/SupplierProfile/components/Demos'
import { RatesList } from 'containers/SupplierProfile/components/Rates'
import SupplierOnboarding from 'containers/AdminSupplierOnboarding'
import AnnouncementsPage from 'containers/AnnouncementsPage'
import AnnouncementDetails from 'containers/AnnouncementsPage/components/AnnouncementDetails'
import AgenciesPage from 'containers/AgenciesPage'
import Files from 'components/Files'
import OrderDetailsPane from 'containers/CustomerOrdersPage/components/OrderDetailsPane'
import UserSettingsPage from 'containers/UserSettingsPage'
import retake from "containers/ReportPage/RetakeReport/retake";
import OrderPage from 'containers/OrderPage'
import SidebarLayout from 'components/SidebarLayout'
import useCurrentUser from 'hooks/useCurrentUser'
import { Card, Chip, LoadingFull, Table, Button } from '@arnsbogroup/react-voicearchive'
import Aside from 'components/Aside'
import Icon from 'components/Icon'
import { Contact } from 'components/datatable'
import { useKeyboardShortcut } from '@arnsbogroup/react-voicearchive/lib/hooks'
import SearchPage from 'containers/SearchPage'
import { FormattedDate, FormattedTime } from 'react-intl'
import classNames from 'classnames'
import SupplierInfoPage from 'containers/SupplierInfoPage'
import AddAgency from 'containers/AgenciesPage/components/AddAgency'
import NewUserPage from 'containers/NewUserPage'
import CustomerPage from './containers/CustomerPage'
import AccountingMergeInvoicesPage from 'containers/Accounting/AccountingMergeInvoicesPage'
import AccountingToBePaidTasksPage from "containers/Accounting/AccountingToBePaidTasksPage";
import AccountingDraftOrdersPage from "containers/Accounting/AccountingDraftOrdersPage"
import TaskSearchPage from 'containers/TaskSearchPage'
import SchedulingPollPage from 'containers/SchedulingPollPage'
import SchedulingPollCreatePage from 'containers/SchedulingPollPage/components/SchedulingPollCreatePage'
import SchedulingPollDetailPage from 'containers/SchedulingPollPage/components/SchedulingPollDetailPage'
import SchedulingPollEditPage from 'containers/SchedulingPollPage/components/SchedulingPollEditPage'
import PublicSchedulingPollPage from 'containers/PublicSchedulingPollPage'
import MemoryBankPage from 'containers/MemoryBankPage'
import DynamicReports from 'containers/DynamicReports'
import FeatureFlaggingPage from 'containers/FeatureFlaggingPage'
import SupplierPrioritiesPage from 'containers/SupplierPrioritiesPage'
import MemoryDetails from 'components/MemoryDetails'
import NewOrderModal from 'components/NewOrderModal'
import AdSheetImportPage from 'containers/AdSheetImportPage'
import PreviewFile from 'components/PreviewFile'
import NiceModal  from '@ebay/nice-modal-react'

const Span = ({ children }) => <span>{ children }</span>

const CreatedAt = ({ created_at }) => {
  const value = new Date(created_at)
  return (
    <div className="space-x-1">
      <span>
        <FormattedDate value={value} />
      </span>
      <span>
        <FormattedTime value={value} />
      </span>
    </div>
  )
}

const Fallback = () => {
  useEffect(() => {
    window.location = '/'
  }, [])

  return null
}

const CoordinatorApp = ({ history, currentUser, partner }) => {
  const { features = [], routes } = useCurrentUser()


  return (
    <Router history={history}>
      <MaybeSidebarLayout partner={partner} routes={routes}>
        <div className="flex h-full w-full">
          <Route path="/" component={OrderFilesPage} />
          <Route path="/" component={NotificationsPage} />

          <Route path="/" render={({ history, location: { search } }) => {
            const params = new URLSearchParams(search)
            const orderHistoryId = params.get('orderHistoryId')
            params.delete('orderHistoryId')

            return !orderHistoryId ? null : (
              <Aside onClose={() => history.push('?' + params.toString())}>
                <OrderDetailsPane order={{ uid: orderHistoryId }} />
              </Aside>
            )
          }} />

          <Route path="/" render={({ history, location: { search } }) => {
            const params = new URLSearchParams(search)
            const orderId = params.get('orderFilesId')
            params.delete('orderFilesId')
            return !orderId ? null : (
              <Aside onClose={() => history.push('?' + params.toString())}>
                <Files orderId={orderId} />
              </Aside>
            )
          }} />

          <Route path="/suppliers/new" render={() => {
            if (confirm("Are you sure you want to create a new supplier?")) {
              fetch(`/rest/v2/supplier/skeleton`, {
                  method: 'POST',
              })
              .then((response) => response.json())
              .then((response) => {
                  if (response.success) {
                      history.push(`/suppliers/${response.data.uid}/overview`)
                  } else {
                      toastr.error(response.errors)
                      history.push(`/dashboard`)
                  }
              }).catch((error) => {
                  toastr.error(error)
              })
            } else {
              history.push(`/dashboard`)
            }
          }} />
          <Route path="/customers/new" render={() => {
            if (confirm("Are you sure you want to create a new Company?")) {
              fetch(`/rest/v2/customer/skeleton`, {
                  method: 'POST',
              })
              .then((response) => response.json())
              .then((response) => {
                  if (response.success) {
                      history.push(`/customers/${response.data.uid}/contact-info`)
                  } else {
                      toastr.error(response.errors)
                      history.goBack()
                  }
              }).catch((error) => {
                  toastr.error(error)
                  history.goBack()
              })
            } else {
              history.goBack()
            }
          }} />
          <Route path="/suppliers" render={(props) => (
            <SupplierSearchPage history={history} {...props} />
          )} />
          
          <Route path="/agencies" render={(props) => (
            <div className={ props.match.isExact ? 'w-full' : undefined }>
              {props.match.isExact &&
                <div className='m-2'>
                  <AddAgency />
                </div>
              }
              <SearchPage {...props}
                containerClassName="w-full"
                baseApiUrl="/rest/v2/agency"
                components={{
                  Tr: ({ childProps = {}, ...innerProps }) => {
                    return (
                      <Table.Tr
                        {...innerProps }
                        className={classNames({
                          'cursor-pointer': !!childProps,
                          'bg-blue-50': props?.location?.pathname.startsWith(`/agencies/${childProps?.uid}`),
                        })}
                        onClick={childProps.uid ? () => history.push(`/agencies/${childProps.uid}/members`) : undefined}
                      />
                    )
                  },
                  Td: ({ childProps = {}, ...props }) => (
                    <Table.Td
                      {...props }
                    />
                  )
                }}
                head={{
                  uid: { className: 'w-24', label: 'ID' },
                  username: { label: 'Contact Person' },
                  name: { label: 'Name' },
                  email: { label: 'Email' },
                }}
                body={!props.match.isExact ? {
                  uid: Span,
                  username: (entry) => (
                    <Span>{entry?.headSupplier?.userid}</Span>
                  ),
                } : {
                  uid: Span,
                  username: Span,
                  name: Span,
                  email: Span,
                }}
              />
            </div>
              
          )} />

          <Route path="/customers" render={(props) => (
            <SearchPage {...props}
              baseApiUrl="/rest/v2/customer"
              components={{
                Tr: ({ childProps, ...innerProps }) => (
                  <Table.Tr
                    {...innerProps }
                    className={classNames({
                      'cursor-pointer': !!childProps,
                      'bg-blue-50': props?.location?.pathname.startsWith(`/customers/${childProps?.uid}`),
                    })}
                    onClick={childProps?.uid ? () => history.push(`/customers/${childProps.uid}/contact-info`) : undefined}
                  />
                )
              }}
              head={{
                uid: { sortable: true, className: 'w-20' },
                orders: { sortable: true, className: 'w-20' },
                name: { sortable: true },
                email: { sortable: true },
                orders: { sortable: true },
              }}
              body={!props.match.isExact ? {
                uid: Span,
                name: Span,
              } : {
                uid: Span,
                company_id: ({ company_id }) => (company_id > 0 ?
                  <a
                    onClick={(e) => e.stopPropagation()}
                    href={`https://my.arnsbogroup.com/crm/company/details/${company_id}/`}
                    target="_blank"
                    className="text-primary hover:text-primary-darker"
                  >
                    { company_id } <Icon icon="external-link" className="text-xs" />
                  </a> : null
                ),
                name: Span,
                country: Span,
                email: Span,
                orders: Span,
                type: Span,
              }}
            />
          )} />

          <Route path="/scheduling-poll/:schedulingPollHashId" render={(props) => (
            <PublicSchedulingPollPage history={history} {...props} />
          )} />

          <Route path="/scheduling-polls" render={(props) => (
            <div className={props.match.isExact ? 'w-full' : undefined}>
              <SchedulingPollPage history={history} {...props} />
            </div>
          )} />

          <Route path="/memory-bank" render={(props) => (
            <div className={props.match.isExact ? 'w-full' : undefined}>
              <MemoryBankPage history={history} {...props} />
            </div>
          )} />

          <Route path="/tasks" render={(props) => (
            <TaskSearchPage history={history} {...props} />
          )} />

          <Route path="/orders" render={(props) => (
            <OrderSearchPage history={history} {...props} />
          )} />

          <Route path="/handovers" render={(props) => (
            <HandoverPage {...props} />
          )} />

          <Route path="/projects" render={(props) => (
            <SearchPage {...props}
              baseApiUrl="/rest/v2/project"
              head={{
                uid: { className: 'w-24', label: 'ID' },
                hash_id: { className: 'w-40', label: 'Short ID' },
                total_votes: { label: 'Total Votes' },
              }}
              body={{
                uid: Span,
                created_at: CreatedAt,
                hash_id: Span,
                href: ({ href }) => <a href={href} className="text-primary" target="_blank">{ href }</a>,
                total_votes: ({ total_votes, voters }) => <Span
                    title={ voters.map(voter => voter.name + " (" + voter.email + ")").join('\n')}
                  >
                    {total_votes}
                  </Span>,
                creator: ({ creator }) => (
                  <Contact
                    contact_name={creator?.name}
                    contact_email={creator?.email}
                    contact_image={creator?.image}
                  />
                ),
              }}
            />
          )} />

          <Route path="/preview/:fileId" render={(props) => (
            <PreviewFile fileId={props.match.params.fileId} {...props} />
          )} />

          <Route path="/announcements" render={(props) => (
            <div className={props.match.isExact ? 'w-full' : undefined}>
              <AnnouncementsPage history={history} {...props} />
            </div>
          )} />

          <Switch>
            <Route exact path="/" component={CoordinatorDashboardPage} />
            <Route path="/orders/new" render={() => {NiceModal.show(NewOrderModal, { history })}} />,
            <Route path="/orders/ad-import" component={AdSheetImportPage} />,
            <Route path="/orders/:orderId/jobs/:jobId/versions/:versionId/tasks/:taskId" component={OrderPage} />,
            <Route path="/orders/:orderId/jobs/:jobId/versions/:versionId" component={OrderPage} />,
            <Route path="/orders/:orderId/jobs/:jobId" component={OrderPage} />,
            <Route path="/orders/:orderId" render={(props) => (
                  <OrderPage {...props} />
            )}/>,

            <Route path="/task/:taskId" component={CoordinatorTaskRedirectPage} />

            <Route path="/dashboard" component={CoordinatorDashboardPage} />
            <Route path="/settings" component={UserSettingsPage} />

            <Route path="/accounting/merge-invoices" component={AccountingMergeInvoicesPage} />
            <Route path="/accounting/to-be-paid-tasks" component={AccountingToBePaidTasksPage} />
            <Route path="/accounting/accounting-draft-orders" component={AccountingDraftOrdersPage}/>

            <Route path="/suppliers/onboarding" component={SupplierOnboarding} />

            <Route path="/agencies/:agencyId" render={(props) => (
                  <AgenciesPage agencyId={props.match.params.agencyId}/>
            )} />
            
            <Route path="/users/new/:userType" render={(props) => (
                  <NewUserPage newUserType={props.match.params.userType}/>
            )} />
            
            <Route path="/supplier/:supplierId/data" component={SupplierDataTab} />
            <Route path="/supplier/:supplierId/profile" component={SupplierPublicProfile} />
            <Route path="/supplier/:supplierId/rates" component={RatesList} />
            <Route path="/docs" component={SupplierInfoPage} />
            <Route path="/supplier/:supplierId/demos" render={(props) => (
              <SupplierDemos admin {...props} />
            )} />
            <Route path="/report/retake" component={retake}/>
            <Route path="/dynamic-reports" component={DynamicReports} />
            <Route path="/feature-flags" component={FeatureFlaggingPage} />
            <Route path="/supplier-priorities" component={SupplierPrioritiesPage} />
            <Redirect from="/talent/sign-up" to="/suppliers/onboarding" />
            <Route path="/user/sign-in" component={Fallback} />
            <Route path="/user/forgot" component={Fallback} />
            <Redirect from="/reload-dashboard" to="/dashboard" />

            <Route path="/reports" render={(props) => (
              <div>
                {Object.entries(routes.reports || {}).map(([section, reports]) => (
                  <div className="p-4 space-y-2">
                    <h1 className="font-medium text-lg">{ section }</h1>
                    <div className="grid grid-cols-4 gap-3">
                      { reports.map(([name, description, to, beta = false]) => (
                        <Link to={to} onClick={(event) => {
                          if (to.endsWith('.csv')) {
                            event.preventDefault()
                            event.stopPropagation()
                            window.open(to, '_blank')
                          }
                        }}>
                          <Card className="p-4 flex justify-between items-center">
                            <div className="space-x-2">
                              <span className="font-medium">{ name }</span>
                              { beta &&
                                <Chip size="xs" state="warning">Beta</Chip>
                              }
                            </div>

                            { to.endsWith('.csv') &&
                                <Chip size="xs" state="info">CSV</Chip>
                            }
                          </Card>
                        </Link>
                      )) }
                    </div>
                  </div>
                )) }
              </div>
            )} />

            <Route path="/suppliers/:id" render={(props) => (
              <div className="w-full h-full flex">
                <div className="w-full">
                  <SupplierPage history={history} supplierId={props.match.params.id} partner={partner}/>
                </div>
              </div>
            )} />

            <Route path="/customers/idle" component={CustomersIdlePage} />
            <Route path="/customers/success-teams" component={CustomersSuccessTeamsPage} />

            <Route path="/customers/:id" render={(props) => (
              <div className="w-full h-full flex">
                <div className="w-full">
                  <CustomerPage customerId={props.match.params.id}/>
                </div>
              </div>
            )} />

            <Route
                path={`/scheduling-polls/create`}
                render={(props) => (
                  <div className="w-full">
                    <SchedulingPollCreatePage {...props} />
                  </div>
                )}
            />
            <Route
                path={`/scheduling-polls/:id/edit`}
                render={(props) => (
                  <div className="w-full">
                    <SchedulingPollEditPage {...props} />
                  </div>
                )}
            />
            <Route
                path={`/scheduling-polls/:id`}
                render={(props) => (
                  <div className="w-full">
                    <SchedulingPollDetailPage {...props} />
                  </div>
                )}
            />
            <Route
                path="/memory-bank/:uid"
                render={(props) => (
                  <div className="w-full p-4 overflow-auto">
                    <MemoryDetails resourceId={+props.match.params.uid} />
                  </div>
                )}
            />
            <Route
                path="/announcements/:uid"
                render={(props) => (
                  <div className="w-full p-4 overflow-auto">
                    <AnnouncementDetails resourceId={+props.match.params.uid} />
                  </div>
                )}
            />
          </Switch>
        </div>
      </MaybeSidebarLayout>
    </Router>
  )
}

const MaybeSidebarLayout = ({ partner, disabled = false, routes, children, ...props }) => {

  const [notifications, setNotifications] = useState([]);

  useEffect(() => {

    fetch(`/rest/v2/handover`)
      .then(response => response.json())
      .then((handovers) => {

        let key = "Currently active";
        if (handovers[key] && handovers[key].length > 0) {
          const newNotification = {
            id: 'handover-alert',
            title: 'Handover Alert',
            body: (handovers[key].length == 1) ? 'There is a handover to assign.' : 'There are handovers to assign.',
            markSeen: null,
            created_at: new Date(),
            url: '/dashboard',
          }
          setNotifications((notifications) => [...notifications, newNotification]);
        }

      })
      .catch((err) => {
        console.error(err)
      })

  }, []);

  if (disabled) {
    return children
  }

  const functionalize = (route) => {
    if (route.routes) {
      route.routes = route.routes.map(functionalize)
    }

    if (Array.isArray(route.onClick)) {
      const [args, body] = route.onClick
      route.onClick = new Function(args, body)
    }

    return route
  }

  return (
    <SidebarLayout
      brand={{
        name: '',
        logo: partner === 'voicetome' ?
        'https://voicetome-branding.s3.eu-central-1.amazonaws.com/logo-white-white.png' :
        'https://voicearchive-branding.s3.eu-central-1.amazonaws.com/small-curve-white.svg',
      }}
      apps={routes?.apps}
      routes={routes?.main.map(functionalize) || []}
      footerRoutes={routes?.footer}
      notifications={notifications}
      CommandPalette={CommandPalette}
      version={window?.app.version || null}
      lastUpdate={window?.app.timestamp || null}
    >
      { children }
    </SidebarLayout>
  )
}

export default CoordinatorApp
